import React from 'react';
import { Modal } from 'semantic-ui-react';
import LoomEmbed from './LoomEmbed';

// Popover for a per-company example Loom (Elevator Pitch / Casual Encounter).
// Rendered from the dashboard training cards so users can revisit an example
// any time, independent of the Training Plan's state.
const ExampleVideoModal = ({ open, onClose, video, heading }) => {
  if (!open || !video?.loomId) return null;
  return (
    <Modal open={open} onClose={onClose} size="small" closeIcon>
      <Modal.Header style={{ fontFamily: 'Montserrat' }}>
        {video.title || heading || 'Example'}
      </Modal.Header>
      <Modal.Content>
        <LoomEmbed loomId={video.loomId} title={video.title || heading} />
      </Modal.Content>
    </Modal>
  );
};

export default ExampleVideoModal;
